module.exports = __webpack_public_path__ + "img/image5.720ca470.png";